// extracted by mini-css-extract-plugin
export default {"responsive-grid-2":"site-details_responsive-grid-2__wYHSK"};